export default {
  brand: 'CrypPay',
  transferHint: 'Lütfen aşağıdaki adrese transfer yapın',
  rechargeAmount: 'Yükleme tutarı',
  rechargeAddress: 'Yükleme adresi',
  scanTip: 'Cüzdanınızla QR kodu tarayarak ödeme yapın',
  copy: 'Kopyala',
  copied: 'Kopyalandı',
  copyFail: 'Kopyalama başarısız',
  networkFee: 'Ağ ücreti',
  eta: 'Tahmini varış süresi',
  etaVal: '5-15 dakika',
  actualArrival: 'Alacağınız tutar',
  noticeTitle: 'Önemli',
  notice1: 'Lütfen yalnızca bu sayfada gösterilen QR koduna veya adrese transfer yapın. Yanlış adrese gönderilen varlıklar geri alınamaz.',
  notice2: 'Transfer tutarı mutlaka {amount} {coin} olmalıdır. Tutar farklı olursa otomatik olarak yatırılmaz.',
  notice3: 'Blockchain onayını bekleyin (genellikle 1 onaydan sonra otomatik olarak hesaba geçer).',
  notice4: 'Blockchain transferleri geri alınamaz. Kullanıcı hatasından kaynaklanan kayıplar kullanıcıya aittir.',
  selectLang: 'Dil seç',
  pending: 'Beklemede',
  paid: 'Ödendi',
  timeout: 'Süresi doldu',
  orderNo: 'Sipariş',
  loading: 'Yükleniyor…',
  paramError: 'Bağlantı parametreleri eksik',
  initFail: 'Sipariş oluşturulamadı',
  paidSuccess: 'Ödeme başarılı',
  timedOut: 'Sipariş süresi doldu, lütfen yeniden başlatın'
}